export default __webpack_public_path__ + "static/media/greenctg.d239d568.jpg";